import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "dc3a2UwCYdJQZKpcmXSLdlV", "DataManager", undefined);

import { size, view, UITransform, rect, misc } from "cc";
import { E_EventType } from "../EnumBase";
import { App } from "./App";

var DataManager = /*#__PURE__*/function () {
  function DataManager() {
    _defineProperty(this, "_isShake", false);

    _defineProperty(this, "_coin", 0);

    _defineProperty(this, "_lineOwn", "");

    _defineProperty(this, "_lineCur", 0);

    _defineProperty(this, "_lineUnlock", "");

    _defineProperty(this, "_ballOwn", "");

    _defineProperty(this, "_ballCur", 0);

    _defineProperty(this, "rate_z2h", 1);

    _defineProperty(this, "_visibleSize", null);

    _defineProperty(this, "_vSize_game", null);

    _defineProperty(this, "vBaseSize_game", size());

    _defineProperty(this, "zBaseIndex_game", 0);

    _defineProperty(this, "mapLen", 0);

    _defineProperty(this, "rate_uiToGame", 0);

    _defineProperty(this, "zMax_camGame", 240);

    _defineProperty(this, "hBall_minInGame", 0);

    _defineProperty(this, "hPreTip_minInGameUI", 0);

    _defineProperty(this, "_tollgateLv", 1);

    _defineProperty(this, "_giftPg", 0);

    _defineProperty(this, "_giftLineIndex", 0);

    _defineProperty(this, "_magnetismLv", 0);

    _defineProperty(this, "_accelerateLv", 0);

    _defineProperty(this, "magnetismRange", 50);

    _defineProperty(this, "magnetismOffset", 0.04);

    _defineProperty(this, "accelerateRange", 50);

    _defineProperty(this, "accelerateOffset", 0.05);
  }

  var _proto = DataManager.prototype;

  /**初始化数据 */
  _proto.init = function init() {
    // this._coin = App.LocalDBMgr.coin;
    this._tollgateLv = App.LocalDBMgr.TollgateLv;
    this._ballCur = App.LocalDBMgr.ballCur;
    this._ballOwn = App.LocalDBMgr.ballOwn;
    this._lineCur = App.LocalDBMgr.lineCur;
    this._lineOwn = App.LocalDBMgr.lineOwn;
    this._lineUnlock = App.LocalDBMgr.lineUnlock;
    this._magnetismLv = App.LocalDBMgr.MagnetismLv;
    this._accelerateLv = App.LocalDBMgr.Accelerate;
    this._giftPg = App.LocalDBMgr.GiftPg;
    this._giftLineIndex = App.LocalDBMgr.GiftLineIndex;
    this._coin = App.LocalDBMgr.coin;
    this.rate_z2h = this.calcRateZ2H();
    this.initY_gameMin(); // this.visibleSize = view.getCanvasSize();
  };

  _proto.initY_gameMin = function initY_gameMin() {
    var size_canvas = view.getCanvasSize();
    var cam_game = App.GameCtrl.cam_game;
    this.hBall_minInGame = cam_game.rect.y * size_canvas.height;
    this.hPreTip_minInGameUI = this.visibleSize.height * App.GameCtrl.cam_game.rect.y;
  }
  /**
   * 计算相机z的最大值
   * @param bgW 背景width
   */
  ;

  _proto.calcZMax_camGame = function calcZMax_camGame(bgW) {
    var cam_game = App.GameCtrl.cam_game; //摄像机的拍摄尺寸

    var fov = misc.degreesToRadians(cam_game.fov);
    var v_tan = Math.tan(fov / 2);
    this.zMax_camGame = bgW / 2 / v_tan;
  }
  /**根据相机的zIndex， 计算渲染尺寸 */
  ;

  _proto.calcGameCamSize = function calcGameCamSize() {
    var cam_game = App.GameCtrl.cam_game;
    var vSize_ui = this._visibleSize; //摄像机的拍摄尺寸

    var zIndex = cam_game.node.position.z;
    var fov = misc.degreesToRadians(cam_game.fov);
    var v_tan = Math.tan(fov / 2);
    var w = zIndex * v_tan * 2;
    var h = w * vSize_ui.height * (1 - cam_game.rect.y) / vSize_ui.width;
    this._vSize_game = size(w, h);
  };

  _proto.getCamSizeByZ = function getCamSizeByZ(z) {
    var cam_game = App.GameCtrl.cam_game;
    var vSize_ui = this._visibleSize; //摄像机的拍摄尺寸

    var zIndex = z;
    var fov = misc.degreesToRadians(cam_game.fov);
    var v_tan = Math.tan(fov / 2);
    var w = zIndex * v_tan * 2;
    var h = w * vSize_ui.height * (1 - cam_game.rect.y) / vSize_ui.width;
    return size(w, h);
  };

  _proto.calcSizeGameByYoffset = function calcSizeGameByYoffset(yOffset) {
    var h = this.vBaseSize_game.height + yOffset;
    var w = h * this.vBaseSize_game.width / this.vBaseSize_game.height;
    this.vSize_game = size(w, h);
  }
  /**根据渲染尺寸  计算相机的zindex */
  ;

  _proto.getGameCamZidnex = function getGameCamZidnex() {
    var cam_game = App.GameCtrl.cam_game; //摄像机的拍摄尺寸

    var fov = misc.degreesToRadians(cam_game.fov);
    var v_tan = Math.tan(fov / 2);
    return this._vSize_game.width / 2 / v_tan;
  };

  _proto.getZOffsetByHOffset = function getZOffsetByHOffset(hOffset) {
    var cam_game = App.GameCtrl.cam_game;
    var vSize_ui = this._visibleSize; //摄像机的拍摄尺寸

    var zIndex = 1;
    var fov = misc.degreesToRadians(cam_game.fov);
    var v_tan = Math.tan(fov / 2);
    var w = zIndex * v_tan * 2;
    var h = w * vSize_ui.height * (1 - cam_game.rect.y) / vSize_ui.width;
    return hOffset / h;
  }
  /**计算zIndex和高度的转换比例 */
  ;

  _proto.calcRateZ2H = function calcRateZ2H() {
    var cam_game = App.GameCtrl.cam_game;
    var vSize_ui = this._visibleSize; //摄像机的拍摄尺寸

    var zIndex = 1;
    var fov = misc.degreesToRadians(cam_game.fov);
    var v_tan = Math.tan(fov / 2);
    var w = zIndex * v_tan * 2;
    var h = w * vSize_ui.height * (1 - cam_game.rect.y) / vSize_ui.width;
    return h;
  }
  /**相机拍摄画面在屏幕上的映射范围 */
  ;

  _proto.calcGameCamRect = function calcGameCamRect() {
    var cam_game = App.GameCtrl.cam_game;
    var vSize_ui = this._visibleSize; //摄像机的映射范围(0 -> 1)

    var n_panel = App.GameCtrl.n_drawPanel; // let ht_panel: number = n_panel.position.y + vSize_ui.height / 2 + n_panel.getComponent(UITransform)!.contentSize.height / 2;

    var rateH = n_panel.getComponent(UITransform).contentSize.height / vSize_ui.height;
    cam_game.rect = rect(0, rateH, 1, 1 - rateH);
  }
  /**计算可视区域 */
  ;

  _proto.calcVisibleSize = function calcVisibleSize() {
    /**showAll 适配时 的缩放 */
    var canvasSize = view.getCanvasSize();
    var designSize = size(750, 1334);
    var scaleForShowAll = Math.min(canvasSize.width / designSize.width, canvasSize.height / designSize.height);
    /**showAll 模式下 的实际展示宽高 */

    var realSize = size(designSize.width * scaleForShowAll, designSize.height * scaleForShowAll);
    /**showAll模式下， 将画布拉满全屏的最小缩放 */

    var scale_w = canvasSize.width / realSize.width;
    var scale_h = canvasSize.height / realSize.height;
    App.DataMgr.visibleSize = size(designSize.width * scale_w, designSize.height * scale_h);
  };

  _proto.initBallTex = function initBallTex() {
    var ballTex = new Map();

    for (var i = 1; i < 12; i++) {
      ballTex.set(i - 1, "ball_skin_" + i);
    }

    var arr = ["ball_skin_candy", "ball_skin_coockie", "ball_skin_egg", "ball_skin_heart", "ball_skin_orange_fruit", "ball_skin_planet_earth", "ball_skin_pokeball", "ball_skin_smile_B", "ball_skin_smile_D", "ball_skin_smile_kaka", "ball_skin_snowball", "ball_skin_threads", "ball_skin_USA"];

    for (var j = 0; j < arr.length; j++) {
      ballTex.set(j + 11, arr[j]);
    }

    return ballTex;
  };

  _createClass(DataManager, [{
    key: "isShake",
    get: function get() {
      return this._isShake;
    },
    set: function set(v) {
      this._isShake = v;
      App.LocalDBMgr.shakeState = v;
    }
    /**金币 - 拥有 */

  }, {
    key: "coin",
    get: function get() {
      return this._coin;
    },
    set: function set(v) {
      if (this._coin != v) {
        if (v < 0) v = 0;
        this._coin = v;
        App.LocalDBMgr.coin = v;
        App.EventMgr.handleEvent(E_EventType.Coin_Change);
      }
    }
    /**线 - 拥有 */

  }, {
    key: "lineOwn",
    get: function get() {
      return this._lineOwn;
    },
    set: function set(v) {
      if (this._lineOwn != v) {
        this._lineOwn = v;
        App.LocalDBMgr.lineOwn = v;
      }
    }
    /**线 - 当前使用 */

  }, {
    key: "lineCur",
    get: function get() {
      return this._lineCur;
    },
    set: function set(v) {
      if (this._lineCur != v) {
        this._lineCur = v;
        App.LocalDBMgr.lineCur = v;
      }
    }
    /**线 - 已经解锁 */

  }, {
    key: "lineUnlock",
    get: function get() {
      return this._lineUnlock;
    },
    set: function set(v) {
      if (this._lineUnlock != v) {
        this._lineUnlock = v;
        App.LocalDBMgr.lineUnlock = v;
      }
    }
    /**球 - 拥有*/

  }, {
    key: "ballOwn",
    get: function get() {
      return this._ballOwn;
    },
    set: function set(v) {
      if (this._ballOwn != v) {
        this._ballOwn = v;
        App.LocalDBMgr.ballOwn = v;
      }
    }
    /**球 - 当前使用 */

  }, {
    key: "ballCur",
    get: function get() {
      return this._ballCur;
    },
    set: function set(v) {
      if (this._ballCur != v) {
        this._ballCur = v;
        App.LocalDBMgr.ballCur = v;
      }
    }
    /**zIndex和 h 的转换比例 */

  }, {
    key: "visibleSize",
    get: function get() {
      return this._visibleSize;
    },
    set: function set(v) {
      this._visibleSize = v;
    }
    /** game 可见区域 */

  }, {
    key: "vSize_game",
    get: function get() {
      return this._vSize_game;
    },
    set: function set(v) {
      this._vSize_game = v;
    }
    /**game 基础渲染尺寸 */

  }, {
    key: "tollgateLv",
    get: function get() {
      return this._tollgateLv;
    },
    set: function set(v) {
      if (this._tollgateLv != v) {
        this._tollgateLv = v;
        App.LocalDBMgr.TollgateLv = v;
      }
    }
    /**礼物进度 */

  }, {
    key: "giftPg",
    get: function get() {
      return this._giftPg;
    },
    set: function set(v) {
      this._giftPg = v;
      App.LocalDBMgr.GiftPg = v;
    }
    /**礼物index */

  }, {
    key: "giftLineIndex",
    get: function get() {
      return this._giftLineIndex;
    },
    set: function set(v) {
      this._giftLineIndex = v;
      App.LocalDBMgr.GiftLineIndex = v;
    }
    /**磁铁等级 */

  }, {
    key: "magnetismLv",
    get: function get() {
      return this._magnetismLv;
    },
    set: function set(v) {
      if (this._magnetismLv != v) {
        this._magnetismLv = v;
        App.LocalDBMgr.MagnetismLv = v;
      }
    }
    /**加速等级 */

  }, {
    key: "accelerateLv",
    get: function get() {
      return this._accelerateLv;
    },
    set: function set(v) {
      if (this._accelerateLv != v) {
        this._accelerateLv = v;
        App.LocalDBMgr.Accelerate = v;
      }
    }
    /**磁铁 */

  }], [{
    key: "I",
    get: function get() {
      if (!DataManager._I) {
        DataManager._I = new DataManager();
      }

      return DataManager._I;
    }
    /**
     * 是否支持振动效果 - 振动状态
     */

  }]);

  return DataManager;
}();

_defineProperty(DataManager, "_I", null);

export { DataManager as default };

_cclegacy._RF.pop();